type FetchWithIntervalParams = {
	callback: () => void;
	time?: number;
};
export const handleRequestRetry = ({
	callback,
	time = 5000,
}: FetchWithIntervalParams) => {
	setTimeout(() => {
		callback();
	}, time);
};
export const CALIBRATION_RETRY_TIME = 5000;
export const WIZARD_SESSION_RETRY_TIME = 5000;
